import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Card,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import UpdateOutlinedIcon from "@mui/icons-material/UpdateOutlined";
import dayjs from "dayjs";
import "jspdf-autotable";
import { useStyles } from "../../theme/appStyles";
import useUser from "../../Core/hook/useUser";
import Pagination from "../../Components/Pagination";
import { CiEdit } from "react-icons/ci";
import { Privileges } from "../../Core/Enum/enum";


const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const { id: customerId } = useParams<{ id: string }>();
  const { userHasRight } = useUser();
  useEffect(() => {}, [customerId]);

 

  return (
    <div>
      <Grid container spacing={3}>
          <Grid item lg={6} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.activityHistoryHeaderGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography
                        className={classes.ActivityHistoryHEading}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        Dashboard
                      </Typography>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Grid>
      </Grid>
    </div>
  );
};

export default Index;
